import api from "@/api";
import * as moment from "moment";

/**
 * GET_TODAY_ORDER_LIST && OrderSettled Common Info
 */

// 整理訂單的 user 資訊為一個 userList

const matchUserListByOrderList = orderList => {
  return orderList
    .map(order => {
      order.user.address = JSON.parse(order.user.address);
      order.user.phone = JSON.parse(order.user.phone);
      order.user.prepay = order.user.prepay.split(",") || [];
      order.user.state = false;
      if (!order.user.fixed_time) {
        order.user.fixed_time = [];
        return order.user;
      }
      order.user.fixed_time = order.user.fixed_time.split(",");
      return order.user;
    })
    .filter((set => f => !set.has(f.id) && set.add(f.id))(new Set()));
};

const calcAmount = orderList => {
  return orderList.reduce((acc, cur) => {
    return acc + cur.amount;
  }, 0);
};

//取得當週幾訂餐陣列
// const getWeekList = (req, id) => {
//   return api.getWeekOrder(req, id).then(res => res.week);
// };

//當週幾訂餐陣列轉化為顯示 checkbox
const turnWeekFormat = weekList => {
  let week = [false, false, false, false, false];
  return week.map((day, index) => {
    if (!weekList) return day;
    return weekList.some(weekday => {
      return index + 1 == weekday;
    });
  });
};

//排序送餐日期
const sortOrderList = orderList => {
  return orderList.sort((a, b) => {
    return a.delivered_at > b.delivered_at ?
      1 :
      b.delivered_at > a.delivered_at ?
      -1 :
      0;
  });
};

/**
 * GET_TODAY_ORDER_LIST
 */
export const getUserListWithAllContactInfo = orderAllList => {
  let orderList = matchUserListByOrderList(orderAllList);
  return orderList.map(user => {
    let addressList = [
      user.address.main.city +
      user.address.main.district +
      user.address.main.street
    ];
    if (user.address.other) {
      user.address.other.forEach(address => {
        addressList.push(address.city + address.district + address.street);
      });
    }

    if (!user.cashbag_out_at) user.cashbag_out_at = "尚未送出";

    return {
      user_id: user.id,
      name: user.name,
      address: addressList,
      phone: user.phone.main,
      prepay: user.prepay,
      prepayList: user.prepay,
      cashbag_out_at: user.cashbag_out_at,
      is_cashbag_out: Boolean(user.is_cashbag_out),
      week_status: user.week_status,
      undelivered_prepay: user.undelivered_prepay
    };
  });
};

const getTodayOrders = (orderAllList, user) => {
  return orderAllList
    .filter(order => {
      return user.user_id === order.user_id;
    })
    .filter(order => {
      //過濾日期
      let deadline = moment()
        .subtract("month", 1)
        .unix();
      let nowTime = moment().unix();
      let orderTime = moment(order.delivered_at).unix();
      if (deadline < orderTime && orderTime < nowTime) return order;
    })
    .filter(order => {
      return !(!order.is_paid && order.is_bag_back);
    });
};

const calcPrepay = user => {
  return user.prepay.reduce((acc, cur) => {
    return Number(acc) + Number(cur);
  }, 0);
};
export const fetchUsersWithTodayOrder = orderAllList => {
  let userList = getUserListWithAllContactInfo(orderAllList);
  return userList.map(async user => {
    let orderList = orderAllList.filter(order => {
      return order.user_id == user.user_id;
    });
    sortOrderList(orderList);
    let todayOrderList = getTodayOrders(orderAllList, user);
    let amount = calcAmount(orderList);
    let weekdays = turnWeekFormat(user.week_status);
    let prepay = calcPrepay(user);
    user.week = weekdays;
    user.orderList = todayOrderList;
    user.amount = amount;
    user.prepay = prepay;
    return user;
  });
};

/**
 * OrderSettled
 */
export const fetchUsersWithAllOrder = orderAllList => {
  let userList = matchUserListByOrderList(orderAllList);
  return userList.map(user => {
    let orderList = orderAllList.filter(order => {
      return order.user_id == user.id;
    });
    sortOrderList(orderList);
    let amount = calcAmount(orderList);
    let weekdays = turnWeekFormat(user.week_status);
    let is_amount = orderList.every(order => {
      return order.is_paid;
    });
    let unDeliveredNum = orderList.reduce((acc, cur) => {
      return acc + !cur.is_delivered;
    }, 0);

    if (!user.cashbag_out_at) user.cashbag_out_at = "尚未送出";
    user.is_amount = is_amount;
    user.amount = amount;
    user.unDeliveredNum = unDeliveredNum;
    user.week = weekdays;
    user.orderList = orderList;
    return user;
  });
};

/**
 * BagCardModal
 */

export const orderGetUserInfo = (orderList, userList) => {
  return orderList.map(async order => {
    await userList;
    let user = userList.filter(user => {
      return user.user_id === order.user_id;
    });
    if (user.length == 0) return (order.name = "");
    order.name = user[0].name;
    return order;
  });
};

/**
 * vieworder
 */

export const arrangeSingleUserOrderList = (state, commit, SET_ORDER_LIST) => {
  let orderList = [];
  for (var key in state.singleUserOrderList) {
    state.singleUserOrderList[key].length !== 0 ?
      orderList.push(...state.singleUserOrderList[key]) :
      null;
  }
  commit(SET_ORDER_LIST, orderList);
  let undeliveredList = Array.from(
    new Set(
      orderList
      .filter(order => {
        return !order.is_delivered;
      })
      .map(order => {
        let date = order.delivered_at.split("-");
        return Number(date[2]);
      })
    )
  );
  let unpaidList = Array.from(
    new Set(
      orderList
      .filter(order => {
        return !order.is_paid && order.is_bag_back && order.is_delivered;
      })
      .map(order => {
        let date = order.delivered_at.split("-");
        return Number(date[2]);
      })
    )
  );
  let unBagBackList = Array.from(
    new Set(
      orderList
      .filter(order => {
        return order.is_paid && !order.is_bag_back && order.is_delivered;
      })
      .map(order => {
        let date = order.delivered_at.split("-");
        return Number(date[2]);
      })
    )
  );
  let unBagBackAndUnpaidList = Array.from(
    new Set(
      orderList
      .filter(order => {
        return !order.is_paid && !order.is_bag_back && order.is_delivered;
      })
      .map(order => {
        let date = order.delivered_at.split("-");
        return Number(date[2]);
      })
    )
  );
  let orderFinishList = Array.from(
    new Set(
      orderList
      .filter(order => {
        return order.is_paid && order.is_bag_back && order.is_delivered;
      })
      .map(order => {
        let date = order.delivered_at.split("-");
        return Number(date[2]);
      })
    )
  );
  return {
    undeliveredList,
    unpaidList,
    unBagBackList,
    unBagBackAndUnpaidList,
    orderFinishList
  };
};